/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {BreakdownPreviewProps, BreakdownType} from 'common/onboarding/immersive-onboarding/types';
import {PROPERTY_BREAKDOWN_MAP} from 'common/onboarding/immersive-onboarding/constants';

import {CardSnabbdom} from '../chart-card';

const SERIES = [
  {
    $overall: {all: 45244},
    a: {all: 44781},
    b: {all: 4391},
  },
  {$overall: {all: 22550}, a: {all: 22478}, b: {all: 79}},
  {
    $overall: {all: 25008},
    a: {all: 24880},
    b: {all: 2320},
  },
  {
    $overall: {all: 21522},
    a: {all: 21471},
    b: {all: 912},
  },
];

const getSeries = (events: string[], property) => {
  return events.reduce((data, event, index) => {
    data[event] = SERIES[index];
    data[event][PROPERTY_BREAKDOWN_MAP[property][0]] = data[event].a;
    data[event][PROPERTY_BREAKDOWN_MAP[property][1]] = data[event].b;
    return data;
  }, {});
};

const props = (events: string[], property: BreakdownType) => ({
  cardTitle: `Stacked Bar Sample`,
  chartOptions: {type: `bar-stacked`},
  bookmark: {
    dashboard: {},
    params: {
      sections: {
        cohorts: [],
        filter: [],
        formula: [],
        group: [
          {
            dataset: `$mixpanel`,
            value: `$os`,
            resourceType: `events`,
            profileType: null,
            search: ``,
            dataGroupId: null,
            propertyType: `string`,
            typeCast: null,
            unit: null,
          },
        ],
        show: events.map((event) => ({
          behavior: {
            type: `event`,
            resourceType: `events`,
            name: event,
            search: ``,
            profileType: null,
            filters: [],
            dataGroupId: null,
            dataset: `$mixpanel`,
          },
          measurement: {math: `unique`, property: null, cumulative: false, perUserAggregation: null, rolling: null},
        })),
        time: [{unit: `day`, value: 30}],
      },
      columnWidths: {bar: {}},
      displayOptions: {
        chartType: `bar`,
        plotStyle: `stacked`,
        analysis: `linear`,
        value: `absolute`,
        funnelStepsSelectedTableColumns: null,
      },
      sorting: {
        bar: {
          sortBy: `column`,
          colSortAttrs: [
            {sortBy: `value`, sortOrder: `desc`},
            {sortBy: `value`, sortOrder: `desc`},
          ],
        },
        line: {
          sortBy: `column`,
          colSortAttrs: [
            {sortBy: `value`, sortOrder: `desc`, valueField: `averageValue`},
            {sortBy: `value`, sortOrder: `desc`, valueField: `averageValue`},
          ],
        },
        table: {
          sortBy: `value`,
          sortOrder: `desc`,
          valueField: `totalValue`,
          viewNLimit: 12,
          colSortAttrs: [{sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`, viewNLimit: 12}],
        },
        'insights-metric': {
          sortBy: `column`,
          colSortAttrs: [
            {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
            {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
          ],
        },
        pie: {
          sortBy: `column`,
          colSortAttrs: [
            {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
            {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
          ],
        },
        'retention-curve': {
          sortBy: `value`,
          sortOrder: `desc`,
          valueField: `size`,
          colSortAttrs: [
            {sortBy: `value`, sortOrder: `desc`, valueField: `size`},
            {sortBy: `value`, sortOrder: `desc`, valueField: `size`},
          ],
        },
      },
      legend: {
        filteredBreakdownSegments: [
          {
            selected: events.map((event) => ({key: event})),
          },
          {selected: PROPERTY_BREAKDOWN_MAP[property].map((prop) => ({key: prop}))},
        ],
      },
    },
  },
  chartParams: {
    computed_at: `2023-11-21T14:29:05.403551+00:00`,
    headers: [`$event`, property],
    date_range: {from_date: `2023-10-22T00:00:00-07:00`, to_date: `2023-11-21T06:33:57.101512-08:00`},
    meta: {
      min_sampling_factor: 1,
      time_period_settings: {quarter_start_month: 1},
      report_sections: {
        group: [],
        show: events.map((event) => ({metric_key: event})),
      },
    },
    series: getSeries(events, property),
  },
  dataGroups: null,
});

export const StackedBarBreakdownPreview = ({events, property}: BreakdownPreviewProps) => {
  //@ts-ignore
  return <CardSnabbdom params={props(events, property)} />;
};
